import { inject } from '@angular/core';
import { FeatureFlagService } from '@core/services/feature-flag/feature-flag.service';
import { ResolveFn } from '@angular/router';

export const featureFlagResolver: ResolveFn<void> = async () => {
  await inject(FeatureFlagService).getAllFeatureFlagsLookup();
}
